import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class Favorite {
    constructor() {
        /**
         * Массив с ID избранных элементов
         * @type {array}
         */
        this.favorite = [];

        /**
         * Массив со всеми кнопками избранного на страничке
         * @type {null|array}
         */
        this.favoriteButtons = null;

        /**
         * Активный класс
         * @type {string}
         */
        this.activeClass = 'is-active';

        /**
         * Блоки "вернуть назад в избранное" в карточке квартиры
         * @type {*[]}
         */
        this.returnBlocks = [];

        this.parent = null;
    }

    init(options) {
        this.favoriteButtons = options.favoriteButtons;

        this.favorite = this._getFavorite();

        this._getReturnBlocks();
        this._bindEvents();

        if (this.favorite.length) {
            this._setState();
        }
    }

    /**
     * Получаем список избранных квартир из куки
     * @returns {array} список избранного из куки
     */
    _getFavorite() {
        const cookieFavorite = Utils.getCookie('favorite');

        if (!cookieFavorite) {
            return [];
        }

        return JSON.parse(cookieFavorite);
    }

    /**
     * Получает элемент в карточке квартиры для возрврата
     */
    _getReturnBlocks() {
        this.favoriteButtons.forEach((favoriteButton) => {
            const block = favoriteButton.parentNode.querySelector('.j-favorite-return');

            if (!block) {
                return;
            }

            const id = favoriteButton.dataset.id;
            const title = favoriteButton.dataset.title;
            const planID = favoriteButton.dataset.plan || 'default';
            const button = block.querySelector('.j-favorite-return-action');

            this.returnBlocks.push({
                favoriteButton,
                block,
                id,
                title,
                planID,
                button
            });
        });
    }

    /**
     * Навешиваем обработчики событий
     * @private
     */
    _bindEvents() {
        if (!this.favoriteButtons.length) {
            return;
        }

        this.favoriteButtons.forEach((button) => {
            const id = button.dataset.id;
            const title = button.dataset.title;
            const planID = button.dataset.plan || 'default';
            const tooltip = button.querySelector('.j-button__tooltip');

            button.setAttribute('data-init', true);

            button.addEventListener('click', (event) => {
                event.preventDefault();

                this.parent = button.closest('.j-flat-ticket');

                this._checkIsDisabledFlat(button);

                this._setFavorite({
                    id,
                    title,
                    planID
                });

                button.classList.toggle(this.activeClass);
                this._setTooltip(tooltip, button.classList.contains(this.activeClass));
            });
        });

        if (!this.returnBlocks.length) {
            return;
        }

        this.returnBlocks.forEach((item) => {
            item.button.addEventListener('click', (event) => {
                event.preventDefault();

                this._setFavorite({
                    id    : item.id,
                    title : item.title,
                    planID: item.plan
                });

                item.favoriteButton.classList.toggle(this.activeClass);
            });
        });
    }

    /**
     * Меняет текст в тултипе
     * @param {HTMLElement} tooltip - тултип конкретной кнопки
     * @param {boolean} isActive - активна ли кнопка
     * @private
     */
    _setTooltip(tooltip, isActive) {
        if (tooltip) {
            tooltip.innerHTML = isActive ? 'Удалить из избранного' : 'Добавить в избранное';
        }
    }

    /**
     * Записываем или удаляем id элемента в локальном хранилище
     * @param {string} id - id элемента
     * @param {string} title - название элемента добавляемого/удаляемого из избранного
     * @param {string} planID - id выбранной планировки
     */
    _setFavorite({id, title, planID = 'default'}) {
        // Проверяем есть ли элемент в массиве
        const isExist = this.favorite.findIndex((item) => {
            return item.id === id && item.planID === planID;
        });

        // Если есть, удаляем, если нет - сохраняем в массив
        if (isExist > -1) {
            this.favorite.splice(isExist, 1);

            observer.publish('favorite:remove', {
                title,
                id,
                planID
            });

            this._showReturnBlock({
                id,
                planID
            });
        } else {
            this.favorite.push({
                id,
                planID
            });

            observer.publish('favorite:add', {
                title,
                id,
                planID
            });

            this._hideReturnBlock({
                id,
                planID
            });
        }

        if (this.favorite.length) {
            Utils.setCookie('favorite', JSON.stringify(this.favorite));
        } else {
            Utils.deleteCookie('favorite');
        }

        observer.publish('favorite:update');
    }

    /**
     * Показывает блок для возврата квартиры в избранное (если квартира не задизейблена)
     * @param {string} id - id элемента
     * @private
     */
    _showReturnBlock({id, planID}) {
        if (!this.returnBlocks.length || this.parent?.classList.contains('is-disabled')) {
            return;
        }

        const returnBlock = this.returnBlocks.find((item) => {
            return item.id === id && item.planID === planID;
        });

        if (!returnBlock) {
            return;
        }

        returnBlock.block.classList.add('is-active');
    }

    /**
     * Скрывает блок для возврата квартиры в избранное
     * @param {string} id - id элемента
     * @private
     */
    _hideReturnBlock({id, planID}) {
        if (!this.returnBlocks.length) {
            return;
        }

        const returnBlock = this.returnBlocks.find((item) => {
            return item.id === id && item.planID === planID;
        });

        if (!returnBlock) {
            return;
        }

        returnBlock.block.classList.remove('is-active');
    }

    _setState() {
        if (!this.favorite.length || !this.favoriteButtons) {
            return;
        }


        this.favoriteButtons.forEach((item) => {
            const isExist = this.favorite.findIndex((element) => {
                return element.id === item.dataset.id && element.planID === item.dataset.plan;
            });

            if (isExist < 0) {
                return;
            }

            const tooltip = item.querySelector('.j-button__tooltip');

            item.classList.add(this.activeClass);
            this._setTooltip(tooltip, item.classList.contains(this.activeClass));
        });
    }

    _checkIsDisabledFlat(button) {
        this.parent = button.closest('.j-flat-ticket.is-disabled');

        if (!this.parent) {
            return;
        }

        this.parent.style.pointerEvents = 'none';
    }
}

export default Favorite;
